module.exports = __webpack_public_path__ + "img/logo_teacher.a97c5abf.png";